import type { IAccessLink } from '../../../../../../../../models/access-link.model';
import TravelTo from '../TravelTo';
import { TransportMode } from '../../../../../../../../models/transport-mode.enum';
import { ISelectedNonPublicTransportLink } from '../../../../models/selected-non-public-transport';
import { DateTimeHelper } from '../../../../../../../../helpers/date-time.helper';

function AccessLink({
  departureAccessLink = undefined,
  arrivalAccessLink = undefined,
  onAccessLinkSelected,
}: {
  departureAccessLink?: IAccessLink;
  arrivalAccessLink?: IAccessLink;
  onAccessLinkSelected: (accessLink: ISelectedNonPublicTransportLink | undefined) => void;
}) {
  const transportMode = departureAccessLink?.transportMode || arrivalAccessLink?.transportMode || TransportMode.unknown;
  const originPlannedTime = departureAccessLink?.origin?.plannedTime || arrivalAccessLink?.origin?.plannedTime;
  const destinationPlannedTime = departureAccessLink?.destination?.plannedTime || arrivalAccessLink?.destination?.plannedTime;
  const originEstimatedTime = departureAccessLink?.origin?.estimatedTime || arrivalAccessLink?.origin?.estimatedTime;
  const destinationEstimatedTime = departureAccessLink?.destination?.estimatedTime || arrivalAccessLink?.destination?.estimatedTime;
  const distanceInMeters = departureAccessLink?.distanceInMeters || arrivalAccessLink?.distanceInMeters;
  const showAsLink = departureAccessLink?.transportMode === TransportMode.walk || arrivalAccessLink?.transportMode === TransportMode.walk;

  return (
    <>
      {showAsLink && (
        // eslint-disable-next-line jsx-a11y/anchor-is-valid
        <a
          href="#"
          className="access-link text-decoration-none d-block btn--outline-internal"
          onClick={(e) => {
            e.preventDefault();
            onAccessLinkSelected({
              departureAccessLink: !!departureAccessLink,
              arrivalAccessLink: !!arrivalAccessLink,
              connectionLinkLegIndex: undefined,
            });
          }}
        >
          <TravelTo
            transportMode={transportMode}
            durationInMinutes={
              originPlannedTime && destinationPlannedTime ? DateTimeHelper.minutes(originEstimatedTime || originPlannedTime, destinationEstimatedTime || destinationPlannedTime) : undefined
            }
            distanceInMeters={distanceInMeters}
            showLinkIcon={true}
          ></TravelTo>
        </a>
      )}
      {!showAsLink && (
        <div className="access-link">
          <TravelTo
            transportMode={transportMode}
            durationInMinutes={
              originPlannedTime && destinationPlannedTime ? DateTimeHelper.minutes(originEstimatedTime || originPlannedTime, destinationEstimatedTime || destinationPlannedTime) : undefined
            }
            distanceInMeters={distanceInMeters}
            showLinkIcon={false}
          ></TravelTo>
        </div>
      )}
    </>
  );
}

export default AccessLink;
